import { render } from "./StatTile.vue?vue&type=template&id=754c5530&scoped=true"
import script from "./StatTile.vue?vue&type=script&lang=js"
export * from "./StatTile.vue?vue&type=script&lang=js"

import "./StatTile.vue?vue&type=style&index=0&id=754c5530&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754c5530"]])

export default __exports__